import type { FormStepId } from 'shared/config/formStepId';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { setIsStepFullFilledByStepId, defaultStepperConfigSelector, selectAllFormFields } from 'entities/creditForm';

import { recalculateSteps } from './stepper';

export const submitAnketaThunk =
  (
    currentStepId?: ValuesOf<typeof FormStepId>,
    options?: Partial<{ isDialog: boolean; onFullySubmitCallback: (data: TCreditFormCommonFields) => void }>,
  ): ThunkResult<void> =>
  async (dispatch, getState) => {
    const { isDialog = false, onFullySubmitCallback } = options || {};

    if (currentStepId && !isDialog) {
      dispatch(
        setIsStepFullFilledByStepId({
          stepId: currentStepId,
          isFullFilled: true,
        }),
      );
    }

    const { activeStep } = recalculateSteps(defaultStepperConfigSelector(getState()));
    if (!isDialog && activeStep?.stepIndex === undefined) {
      onFullySubmitCallback?.(selectAllFormFields(getState()));
    }
  };
